define('ItemBadges.GlobalViews', [
    'ItemBadges.Collection',
    'ItemBadges.View'
], function ItemBadgesGlobalViews(
    ItemBadgesCollection,
    ItemBadgesView
) {
    'use strict';

    var layout;
    var itemBadgesCollection;
    var itemBadgesGlobalViews = {
        loadGlobalViewsItemBadges: function loadGlobalViewsItemBadges(application) {
            layout = application.getComponent('Layout');
            itemBadgesGlobalViews.addGlobalViewsChildViews();
        },

        addGlobalViewsChildViews: function addPDPChildViews() {
            layout.addChildViews(
                'ItemRelations.RelatedItem.View', {
                    'Item.Price': {
                        'Itembadges.View': {
                            childViewIndex: 5,
                            childViewConstructor: function childViewConstructor() {
                                if (!itemBadgesCollection) {
                                    itemBadgesCollection = new ItemBadgesCollection();
                                    itemBadgesCollection.fetch();
                                }
                                return new ItemBadgesView({
                                    collection: itemBadgesCollection
                                });
                            }
                        }
                    }
                }
            );
        }
    };

    return itemBadgesGlobalViews;
});
